import { BREAKPOINTS } from '@skyscanner/backpack-web/bpk-component-breakpoint';
import CloseIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/close';

import STYLES from './Close.module.scss';

import withBpkBreakpoint from '@shared/ui/common/BpkBreakpoint/withBpkBreakpoint';

const Close = ({
  isMobile = false,
  onClose,
}: {
  isMobile?: boolean;
  onClose: Function;
}) => (
  <>
    {isMobile ? null : <div className={STYLES.Close__closeIconMask} />}
    <CloseIcon className={STYLES.Close__closeIcon} onClick={onClose} />
  </>
);

export { Close };

export default withBpkBreakpoint(Close, BREAKPOINTS.MOBILE, 'isMobile');
